import { render, staticRenderFns } from "./BusinessMetricsDetail.vue?vue&type=template&id=bfa2dbf6&scoped=true"
import script from "./BusinessMetricsDetail.vue?vue&type=script&lang=js"
export * from "./BusinessMetricsDetail.vue?vue&type=script&lang=js"
import style0 from "./BusinessMetricsDetail.vue?vue&type=style&index=0&id=bfa2dbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa2dbf6",
  null
  
)

export default component.exports